import { CommonUtilsService } from 'data/services';
import { CommonUtilsServiceInterface } from 'domain/services';
import { makeRemoteGetLastProductVersions } from 'main/factories/usecases/common-utils/remote-get-last-product-versions-factory';

export const makeCommonUtilsService = (): CommonUtilsServiceInterface => {
  return new CommonUtilsService({
    getLastProductVersions: makeRemoteGetLastProductVersions(),
  });
};
